import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgIdee = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFC522"
      fillRule="evenodd"
      d="M16 27.25c-4.097-1.6-7-5.586-7-10.25 0-6.075 4.925-11 11-11s11 4.925 11 11c0 4.664-2.903 8.65-7 10.25V31h-8zM17 33h6v1a3 3 0 1 1-6 0z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M22.5 21.5a1 1 0 1 0-1-1v1zm-2-1a2 2 0 1 1 2 2h-1V34h-1V22.5h-2V29h-1v-6.5H17a2.5 2.5 0 0 1-2.5-2.5v-.5a2 2 0 1 1 4 0v2h2zm-3-1a1 1 0 1 0-2 0v.5a1.5 1.5 0 0 0 1.5 1.5h.5zM9.89 7.182l-.708.707-3.536-3.535.708-.708zM29.646 7.182l.707.707 3.536-3.535-.707-.708zM5.646 28.182l.708.707 3.535-3.535-.707-.707zM33.89 28.182l-.708.707-3.536-3.535.708-.707z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgIdee);

export default ForwardRef;
